'use client';

import React, { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
      style={{
        background: scrolled
          ? 'rgba(0, 100, 0, 0.92)'
          : 'green',
        backdropFilter: scrolled ? 'blur(16px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(244,246,248,0.08)' : '1px solid transparent',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <AppLogo
          text="Upskill"
          iconName="AcademicCapIcon"
          size={32}
          className="text-monitor-white font-display font-semibold tracking-tight text-xl"
        />

        {/* Nav Links */}
        <nav className="hidden md:flex items-center gap-8">
          {['Bootcamps', 'Alumni', 'Studios']?.map((item) => (
            <a
              key={item}
              href={`#${item?.toLowerCase()}`}
              className="text-sm font-medium transition-colors duration-200"
              style={{ color: 'rgba(244,246,248,0.6)' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#F4F6F8')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(244,246,248,0.6)')}
            >
              {item}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <a
          href="#signup"
          className="btn-magnetic pulse-green hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200"
          style={{
            background: '#00E676',
            color: '#0B1A2E',
          }}
        >
          <span
            className="blink w-2 h-2 rounded-full"
            style={{ background: '#0B1A2E', opacity: 0.7 }}
          />
          Start Free Module
        </a>
      </div>
    </header>
  );
}